import {twMerge} from '@sdox/utils'

import type {ReactNode} from 'react'
import type {ClassNameValue} from 'tailwind-merge'

export interface AsideProps {
  className?: ClassNameValue
  children?: ReactNode
}

const asideClasses = twMerge(
  'fixed top-0 h-screen min-w-full bg-surface-tertiary md:left-0',
  'overflow-y-auto overscroll-none',
  'z-40 md:z-10',
  'md:hide-scrollbar md:min-w-sidebar',
  'transition-[right] duration-300 ease-in-out will-change-[right]',
)

export const Aside = (({className, children, ...restProps}: AsideProps) => (
  <aside
    className={twMerge(asideClasses, className)}
    {...restProps}
  >
    {children}
  </aside>
))
